<!--
Announcement - display some banner message here (from stt_applcnt_banner for a specified category)
@author cm359n
-->

<template>
  <div id="contain" class="container" >
    <template v-bind:key="'hideable'+index" v-for="(announcement, index) in announcements">
      <div v-if="canHide && !expiries[index].expired" class="announcement-hideable">
        <div class="announcement-content">
          <h2 class="announcement-header" v-html="titles[index]"></h2>
          <p v-html="announcement"></p>
        </div>
        <div v-if="ctaLinks[index].link" class="cta-container">
          <div class="cta-dismiss" v-if="ctaLinks[index].dismiss">
            <button @click="closeAnnouncement(index)">{{ ctaLinks[index].dismiss }}</button>
          </div>
          <div class="cta-link" @click="handleClick">
            <a class="btn" :href="ctaLinks[index].link" :data-type="ctaLinks[index].type">{{ctaLinks[index].text}}</a>
          </div>
        </div>
        <div class="announcement-close"><button @click="closeAnnouncement(index)" aria-label="Hide announcement"><font-awesome-icon icon="x" size="lg" class="bookingItemIcon"></font-awesome-icon></button></div>
      </div>
      <div v-else-if="!canHide" class="announce-content" v-html="announcement"></div>
    </template>
  </div>
</template>

<script setup>
//Utilities
import { ref, onMounted, defineEmits } from 'vue'
import {useRouter} from 'vue-router';
import axios from 'axios'
import * as lst from '@/components/localStorage.js'

const router = useRouter()


const props = defineProps({
  category: String,
  getTitle: Boolean,
  getExpiry: {
    type: Boolean,
    required: false,
    default: false
  },
  canHide: Boolean
})

const emit = defineEmits(['gotTitle', 'gotExpiry'])

//Data
const dispCategory = ref(props.category)
const title = ref('')
const expiry = ref('')
const announcements = ref([])
const ctaLinks = ref([])
const titles = ref([])
const expiries = ref([])
const ids = ref([])

onMounted(
  () => {
    fetchAnnouncement()
  }
)

function fetchAnnouncement () {
  axios.get('/timetable/banners/category/' + dispCategory.value, {})
    .then(response => {
      // take one banner and display it
      let banners = response.data.banners
      if (typeof banners !== 'undefined' && banners.length > 0) {
        announcements.value = []
        banners.map((b) => {
          announcements.value.push(b.content)
          title.value = b.title
          expiry.value = b.expiryTime
          if(props.canHide){
            //dgm11b - aware this is duplication of the title and expiry parts above and this could all go in an object, not seperate arrays but I'm running out of time to check how it affects the cache clear reminder.vue. Sorry future me/person.
            titles.value.push(b.title)
            expiries.value.push(b.expiryTime)
            ids.value.push(b.bannerId)
          }
        })
        if (props.getTitle) {
          emit('gotTitle', title.value)
        }
        if (props.getExpiry) {
          emit('gotExpiry', expiry.value)
        }
      }
      if(props.canHide){
        extractLinks()
        checkExpiry()
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

function extractLinks() {
  announcements.value.forEach(
    (announcement, index) => {

      const regexLink = /cta-link="([^"]+)"/;
      const regexText = /cta-text="([^"]+)"/;
      const regexType = /cta-type="([^"]+)"/;
      const ctaLink = announcement.match(regexLink);
      const ctaText = announcement.match(regexText);
      const ctaType = announcement.match(regexType);

      const linkObj = {
        link: ctaLink ? ctaLink[1] : null,
        text: ctaText ? ctaText[1] : null,
        type: ctaType ? ctaType[1] : null,
      }

      ctaLinks.value[index] = (linkObj)
      //Save the announcement message only
      announcements.value[index] = announcement.split("|")[0]
    }
  )
}

function closeAnnouncement(index) {
  //Set the v-if variable to hide the element
  expiries.value[index].expired = true
  //Save entry to local storage. Name is closedNotice[banner id]  value is expiry time.
  lst.setValue('closedNotice'+ids.value[index], expiries.value[index].time)
}

//Any links clicked, check if internal app link and route if so
function handleClick(evt) {
  if(evt.target.dataset.type) {
      if(evt.target.dataset.type === 'internal') {
      evt.preventDefault();
      let href= evt.target.getAttribute('href')
      router.push(href)
      }
  }
}

function checkExpiry() {
  const timeNow = new Date().getTime()
  expiries.value.forEach(
    (expiry, index) => {
      let expired = false
      //multiplied by 1000 so its in milliseconds, not seconds
      let expiryTime = expiry * 1000
      //Check if has been previously hidden
      //If not check the expiry time against current time
      const previousHidden = lst.getValue('closedNotice'+ids.value[index])
      if(previousHidden) {
        expired = true
      } else {
        expired = (timeNow > expiryTime)
      }
      expiries.value[index] = {time: expiryTime, expired: expired}
    }
  )
}

</script>

<style>
.announce-content {
  margin-bottom: 6px;
  overflow-wrap: anywhere;
}

/* Closeable announcment */
.announcement-hideable {
    padding: 1rem;
    position: relative;
    width: 90%;
    margin: 1rem auto;
    background-color: var(--uog-blue-10);
}

.announcement-close {
    position: absolute;
    top: 0;
    right: 0;
}

.announcement-close button {
    border:none;
    color: var(--uog-dark-blue);
    background:transparent;
    height: 44px;
    width: 44px;
}

.announcement-hideable .announcement-header {
    font-size:20px;
    color: var(--uog-dark-blue);
    text-align:left;
    font-weight:bold;
    padding-right: 1.5rem;
}

/* Cta buttons */
.cta-container {
    display: flex;
    justify-content: end;
}

.cta-dismiss button {
    border: none;
    background: transparent;
    padding: 0px;
    color: var(--bs-body-color);
}

.cta-dismiss {
    margin-right: 10px;
}

.cta-link .btn {
    font-size: 16px;
    background-color: var(--uog-dark-blue);
    border: solid 1px var(--uog-dark-blue);
    padding: 9px 16px;
    color: #fff;
    margin: 4px 0px;
    line-height: normal;
    transition: background-color 0.4s, color 0.4s, border-color 0.4s;
}

.cta-link .btn:hover{
  background-color: #fff;
  border: solid 1px var(--uog-dark-blue);
  color: var(--uog-dark-blue);
}
</style>
